import { LockOutlined, MailOutlined, UserOutlined } from "@ant-design/icons";
import { Input } from "antd";

export default {
  getForm: ({ loading, isLogin, isSubmitCode }) => {
    const basic = [
      {
        key: "account",
        rules: [
          {
            required: true,
            message: "請輸入帳號"
          }
        ],
        child: (
          <Input
            disabled={loading || isLogin}
            prefix={<UserOutlined className="icon-gray" />}
            placeholder="請輸入帳號"
          />
        )
      },
      {
        key: "password",
        rules: [
          {
            required: true,
            message: "請輸入密碼"
          }
        ],
        child: (
          <Input.Password
            disabled={loading || isLogin}
            prefix={<LockOutlined className="icon-gray" />}
            type="password"
            placeholder="請輸入密碼"
          />
        )
      }
    ];
    const advance = [
      // {
      //   key: "phoneNumber",
      //   rules: [
      //     {
      //       required: true,
      //       message: "請輸入手機號碼",
      //     },
      //   ],
      //   child: (
      //     <Input
      //       placeholder="請輸入手機號碼"
      //       prefix={<MobileOutlined className="icon-gray" />}
      //       addonAfter={
      //         <Button className="suffix-btn" onClick={sendSms} type="primary">
      //           傳送簡訊
      //         </Button>
      //       }
      //     />
      //   ),
      // },
      {
        key: "verifyCode",
        rules: [
          {
            required: true,
            message: "請輸入驗證碼"
          }
        ],
        child: (
          <Input disabled={!isSubmitCode} prefix={<MailOutlined className="icon-gray" />} placeholder="請輸入驗證碼" />
        )
      }
    ];
    return isLogin ? advance : basic;
  }
};
